import { Link } from 'react-router-dom'

import { ArrowRight } from '@/lib/icons'

interface SectionHeaderProps {
  id: string
  title: string
  /** Optional trailing link, e.g. "View all". */
  action?: { label: string; href: string }
}

export function SectionHeader({ id, title, action }: SectionHeaderProps) {
  return (
    <div className="border-glass-border flex items-end justify-between border-b pb-4">
      <h2
        id={id}
        className="text-headline-lg-mobile text-fg md:text-headline-lg"
      >
        {title}
      </h2>
      {action && (
        <Link
          to={action.href}
          className="font-body text-label-caps text-primary hover:text-primary-fixed-dim inline-flex items-center gap-1 rounded-sm uppercase transition-colors"
        >
          {action.label}
          <ArrowRight className="size-4" aria-hidden="true" />
        </Link>
      )}
    </div>
  )
}
